import React from 'react'
import Spinner from '../../components/utils/Spinner'

export default function Confirmation () {
    return (
        <>
            <Spinner/>
        </>
    )
}
